import React from 'react'
import banner from '../assets/homeBanner.jpg'
import "./Home.css"

const Banner = () => {
  return (
    <>
      <div className="banner">
        <img src={banner} alt="banner" />
      </div>
    </>
  )
}

export default Banner;
